

export const PQA_BACKEND_API = process.env.REACT_APP_PQS_BACKEND_API
// export const PQA_BACKEND_API = `https://tn5sc4vj-7004.inc1.devtunnels.ms`
// export const PQA_BACKEND_API = `https://8fc0-2400-adc7-1111-4b00-2dc0-e242-8be9-59e8.ap.ngrok.io`
